(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vibe-sofa"] && !Shopify.designMode) return;
  try {
    
function initialiseSofaPages(){document.querySelectorAll('[data-sofa-showroom]').forEach(function(root){if(root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('[data-filter]').forEach(function(button){button.addEventListener('click',function(){const selected=button.dataset.filter;root.querySelectorAll('[data-filter]').forEach(function(item){item.setAttribute('aria-pressed',String(item===button))});root.querySelectorAll('[data-style]').forEach(function(card){card.hidden=selected!=='all'&&card.dataset.style!==selected})})});root.querySelectorAll('.sf-card-photo').forEach(function(link){link.addEventListener('click',function(){const target=document.getElementById(link.getAttribute('href').slice(1));if(target)target.open=true})});root.querySelectorAll('[data-enquire]').forEach(function(link){link.addEventListener('click',function(){const select=root.querySelector('[data-sofa-select]');if(select)select.value=link.dataset.enquire})})})}
initialiseSofaPages();document.addEventListener('shopify:section:load',initialiseSofaPages);

  } catch(e) { console.error(e); }
})();
})();
